// global
import { goBack } from 'react-router-redux';
// local
// actions
import { pending, rejected, fulfilled } from '../async';
import dispatchError from '../error';
import { showSnackbar } from '../snackbar';
// api
import { listConfirmEdit, saveConfirmEdit } from 'app/api/delivery';

const ACTION_KEY = 'EDIT_CONFIRM_DELIVERY_DATA';

export const search = query => dispatch => {
    dispatch(pending(ACTION_KEY, query));
    listConfirmEdit(query)
        .then(payload => dispatch(fulfilled(ACTION_KEY, payload)))
        .catch(err => {
            dispatch(rejected(ACTION_KEY, err));
            dispatchError(dispatch, err);
        });
};

export function sort(key, column, direction) {
    return {
        type: `${ACTION_KEY}_SORT`,
        payload: { key, column, direction },
    };
}

export function back() {
    return goBack();
}

export const save = (replacements, query) => dispatch => {
    dispatch(pending(ACTION_KEY));
    saveConfirmEdit({ replacements })
        .then(() => {
            dispatch(showSnackbar({ title: 'As alterações realizadas foram salvas.', action: true }));
            dispatch(search(query));
        })
        .catch(err => {
            dispatch(rejected(ACTION_KEY, err));
            dispatchError(dispatch, err);
        });
};

export function reset() {
    return {
        type: `${ACTION_KEY}_RESET`,
    };
}

// Table row methods
export function editRow(key, id, isEdit) {
    return {
        type: `${ACTION_KEY}_EDIT_ROW`,
        payload: { key, id, isEdit },
    };
}

export function saveRow(key, id) {
    return {
        type: `${ACTION_KEY}_SAVE_ROW`,
        payload: { key, id },
    };
}

export function updateRow(key, id, value) {
    return {
        type: `${ACTION_KEY}_UPDATE_ROW`,
        payload: { key, id, value },
    };
}
